/*
 * @Author: your name
 * @Date: 2020-01-12 10:26:14
 * @LastEditTime : 2020-01-19 20:14:13
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \周记 张经伟e:\gi劳务\src\untils\token.js
 */
export function getToken() {
  if (!localStorage.getItem("token")) {
    return "";
  }
  return JSON.parse(localStorage.getItem("token"))
    .replace('"', "")
    .replace('"', "");
}
export function addToken(data) {
  return localStorage.setItem("token", JSON.stringify(data));
}
export function removeToken() {
  return localStorage.removeItem("token");
}
export function getName() {
  return JSON.parse(localStorage.getItem("name"));
}
export function addName(data) {
  return localStorage.setItem("name", JSON.stringify(data));
}



// WEBPACK FOOTER //
// ./src/untils/token.js